const Location = ({location}: ILocation) => {
  return (
    <>
      <div className="flex mt-7">
        <span className="icon-location ml-2 mt-1 text-gray-6"></span>
        <p className=" text-gray-6">{location}</p>
      </div>
    </>
  );
};

export default Location;
